module.exports = __webpack_public_path__ + "img/cb-upload.b0625563.svg";